import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { BsPencil } from 'react-icons/bs'

import Nav from '../../components/Nav'
import ActionButton from '../../components/ActionButton';

function PalletEntryList(props) {
    const pencilIcon = <BsPencil size="14"/>
    const [palletEntries, setPalletEntries] = useState({status: 0, v:[], error:null})

    const dateHead = (date) => {
        var d = new Date(date)
        var options = { day: '2-digit', month: 'numeric', year: 'numeric'};
        return d.toLocaleDateString('sr-latn', options)
    }

    const printTime = (date) => {
        var d = new Date(date)
        var options = { hour:'2-digit', minute: '2-digit'};
        return d.toLocaleTimeString('sr-latn', options)
    }

    useEffect(() => {
        const onListResponse = (data, error) => {
            if (error) {
                setPalletEntries({status: 1, v:[], error: error})
            } else {
                setPalletEntries({status: 1, v:data.pallet_entries ? data.pallet_entries : [], error: null})
            }
        }
        props.backend.PalletEntryList(onListResponse)
    }, [props.backend])

    const getEntryStats = (pe) => {
        return {
            gross_weight_on_entry: pe.pallets.reduce((accumulator, obj) => { return accumulator += Number(obj.gross_weight_on_entry); }, 0.0),
            net_weight_on_entry: pe.pallets.reduce((accumulator, obj) => { return accumulator += Number(obj.net_weight_on_entry); }, 0.0),
            num_pallets: pe.pallets.length,
        }
    }
    
    return (
        <>
        <Nav isMain={false} subtitle="Prijem" {...props} />
        {palletEntries.status === 0 && <div className="loadingOverlay"></div>}
        {palletEntries.status === 1 && 
        <div className="content">
            <p className="contentSubtitle">Prijem u hladnjaču</p><br />
            {props.user.system_role === "admin" &&
            <div className="filterMenu">
            <Link to="/entries/new">
                <ActionButton title="Kreiraj" icon={pencilIcon} />
            </Link>
            </div>
            }
            <div className="hscrollcontainer sticky">
            <table>
                <thead>
                <tr>
                    <th align="center" >Uneto</th>
                    <th align="center" >Zasad</th>
                    <th align="center" >Broj<br />paleta</th>
                    <th align="center" >Bruto<br />( kg )</th>
                    <th align="center" >Neto<br />( kg )</th>
                    <th align="center" >Status</th>
                    <th align="center" >&nbsp; - &nbsp;</th>
                </tr>
                </thead>
                <tbody>
                {palletEntries.v.length === 0 &&
                    <tr><td colSpan="5">Nema unetih zapisa</td></tr>
                }
                {palletEntries.v.length > 0 && palletEntries.v.map(pe => { 
                    let stats = getEntryStats(pe)
                    return (
                        <tr key={pe.id}>
                        <td align="center">{dateHead(pe.created_at)}<br />{printTime(pe.created_at)}</td>
                        <td align="center">{pe.farm.name}</td>
                        
                        <td align="center">{stats.num_pallets}</td>
                        <td align="right">{stats.gross_weight_on_entry.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                        <td align="right">{stats.net_weight_on_entry.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                        <td align="center">{pe.status}</td>
                        <td align="center"><Link to={"/entries/"+ pe.id}>Detalji</Link></td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            </div>    
        </div>
        }
        </>
    )
}

export default PalletEntryList
